import { render, staticRenderFns } from "./playerProfileStats.vue?vue&type=template&id=70853ecb&scoped=true"
import script from "./playerProfileStats.vue?vue&type=script&lang=js"
export * from "./playerProfileStats.vue?vue&type=script&lang=js"
import style0 from "./playerProfileStats.vue?vue&type=style&index=0&id=70853ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70853ecb",
  null
  
)

export default component.exports